var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgHair = function SvgHair(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 28,
    height: 34,
    viewBox: "0 0 0.81 0.99",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.49.09C.2 0-.01.26.1.56c.05.15.12.28.22.35.11.07.42-.19.42-.4C.74.3.69.15.49.09z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.14,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.9256
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M.12.45C.25.45.29.41.35.28.41.18.42 0 .42.22c0 .15.27.29.28.23C.72.25.59.07.38.06.37.06.15.16.13.2.12.24.07.45.12.45z",
    fill: "#000",
    stroke: "#000",
    strokeWidth: 0.06,
    strokeMiterlimit: 22.9256
  })));
};

export default SvgHair;